import { render, staticRenderFns } from "./UpdateEmail.vue?vue&type=template&id=3650a967&scoped=true&"
import script from "./UpdateEmail.vue?vue&type=script&lang=js&"
export * from "./UpdateEmail.vue?vue&type=script&lang=js&"
import style0 from "./UpdateEmail.vue?vue&type=style&index=0&id=3650a967&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3650a967",
  null
  
)

export default component.exports